import { getAccessTokenFromCookie } from "../util/authentication";
import {
  ADD_BASE_SCHEDULE_API,
  GET_CURRENT_EMPLOYEE_MONTHLY_SCHEDULE_MAP_API,
  GET_EMPLOYEE_SCHEDULE_BY_DATE_RANGE_API,
  GET_FREEDAY_STANDARD_RELIEF_MAP,
} from "../util/schedule/scheduleConstants";

export const fetchEmployeeSchedulesByDateRange = async (eid, startDate, endDate, station = null) => {
  let apiEndpoint =
    process.env.REACT_APP_SCHEDULE_EDITOR_API +
    GET_EMPLOYEE_SCHEDULE_BY_DATE_RANGE_API +
    "/" +
    eid +
    "/" +
    startDate +
    "/" +
    endDate;

  if (station) {
    apiEndpoint += "/" + station;
  }

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 404) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const fetchCurrentEmployeeMonthlyScheduleMap = async (eid, station, year, month) => {
  let apiEndpoint =
    process.env.REACT_APP_SCHEDULE_EDITOR_API +
    GET_CURRENT_EMPLOYEE_MONTHLY_SCHEDULE_MAP_API +
    "/" +
    eid +
    "/" +
    station +
    "/" +
    year +
    "/" +
    month;

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 404) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const addBaseSchedule = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_SCHEDULE_EDITOR_API + ADD_BASE_SCHEDULE_API;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw Error(`POST ${apiEndpoint} API Call failed.`, response);
    }
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getFreedayStandardReliefMap = async (station, workgroup, month, year, eid=null) => {
  let apiEndpoint = process.env.REACT_APP_SCHEDULE_EDITOR_API + 
  GET_FREEDAY_STANDARD_RELIEF_MAP +
  "/" +
  station +
  "/" +
  workgroup +
  "/" +
  month +
  "/" +
  year;

  if (eid) {
    apiEndpoint += "/" + eid
  }

  apiEndpoint = encodeURI(apiEndpoint)

  try {
    const response = await fetch(apiEndpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    if (!response.ok) {
      throw Error(`GET ${apiEndpoint} API Call failed.`, response);
    }
    const data = await response.json();
    return data
  } catch (error) {
    console.error(error);
  }
};
